export default __webpack_public_path__ + "3d6172fb7dae1308ad2fbd885c05ad98.png";